import * as React from "react";
import { LabelledElement } from "../../../components/labelled-element/LabelledElement.component";
import Select from "react-select";
import { useEffect, useState } from "react";
import { getReactSelectStyleClasses } from "../../../style/style-functions";
import { COLOR_FLAVIA_BLUE } from "../../../style/predefined-colors";
import { ColorSelect } from "../../../components/color-select/ColorSelect.component";
import { HTMLTooltipWrapper } from "../../../components/html-tooltip/HTMLTooltipWrapper.component";
import { useTranslation } from "react-i18next";
import { ModelUploadContentUtils } from "./ModelUploadContent.util";
export function MeshContent({ onChange }) {
    const { t } = useTranslation();
    const [currentOptions, setCurrentOptions] = useState({
        factorToScaleToMeter: 1,
        position: [0, 1, 0],
        rotation: [0, 0, 0],
        scalable: false,
        outline: true,
        color: COLOR_FLAVIA_BLUE,
        useMeshCollider: false
    });
    useEffect(() => {
        onChange(currentOptions);
    }, [currentOptions]);
    const createScaleOptions = () => {
        return [
            { value: 1, label: t("upload:mesh-scale-option-meter", "Meter") },
            { value: 0.1, label: t("upload:mesh-scale-option-decimeter", "Decimeter") },
            { value: 0.01, label: t("upload:mesh-scale-option-centimeter", "Centimeter") },
            { value: 0.001, label: t("upload:mesh-scale-option-millimeter", "Millimeter") }
        ];
    };
    const createCurrentValue = () => {
        var _a, _b;
        return {
            value: currentOptions.factorToScaleToMeter,
            label: (_b = (_a = createScaleOptions().find((option) => option.value === currentOptions.factorToScaleToMeter)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : "Unknown"
        };
    };
    return (React.createElement("section", { className: "model-upload-dialog-content" },
        React.createElement(HTMLTooltipWrapper, { tooltip: t("upload:select-mesh-scale-tooltip", "The mesh file will be scaled to the selected unit") },
            React.createElement(LabelledElement, { label: t("upload:select-mesh-scale-label", "Metric unit:"), horizontal: true },
                React.createElement(Select, { onChange: (option) => {
                        var _a;
                        setCurrentOptions(Object.assign(Object.assign({}, currentOptions), { factorToScaleToMeter: (_a = option === null || option === void 0 ? void 0 : option.value) !== null && _a !== void 0 ? _a : 1 }));
                    }, options: createScaleOptions(), value: createCurrentValue(), classNames: getReactSelectStyleClasses(), menuPlacement: "auto", menuPortalTarget: document.body }))),
        ModelUploadContentUtils.createTripleNumberInputPosition(currentOptions.position, (position) => {
            setCurrentOptions(Object.assign(Object.assign({}, currentOptions), { position: position }));
        }),
        ModelUploadContentUtils.createTripleNumberInputRotation(currentOptions.rotation, (rotation) => {
            setCurrentOptions(Object.assign(Object.assign({}, currentOptions), { rotation: rotation }));
        }),
        React.createElement("div", { className: "labelled-checkbox-container", "data-tooltip": t("upload:checkbox-mesh-scalable-tooltip", "If this option is not set, users won't be able to scale the model once it has been uploaded") },
            React.createElement("input", { type: "checkbox", checked: currentOptions.useMeshCollider, onChange: (event) => {
                    setCurrentOptions(Object.assign(Object.assign({}, currentOptions), { useMeshCollider: event.target.checked }));
                } }),
            React.createElement("label", null, t("upload:checkbox-mesh-collider-label", "Use Mesh Collider"))),
        React.createElement("div", { className: "labelled-checkbox-container", "data-tooltip": t("upload:checkbox-mesh-scalable-tooltip", "If this option is not set, users won't be able to scale the model once it has been uploaded") },
            React.createElement("input", { type: "checkbox", checked: currentOptions.scalable, onChange: (event) => {
                    setCurrentOptions(Object.assign(Object.assign({}, currentOptions), { scalable: event.target.checked }));
                } }),
            React.createElement("label", null, t("upload:checkbox-mesh-scalable-label", "Scalable"))),
        React.createElement("div", { className: "labelled-checkbox-container", "data-tooltip": t("upload:checkbox-mesh-outline-tooltip", "If this option is set, the model will be rendered with an outline") },
            React.createElement("input", { type: "checkbox", checked: currentOptions.outline, onChange: (event) => {
                    setCurrentOptions(Object.assign(Object.assign({}, currentOptions), { outline: event.target.checked }));
                } }),
            React.createElement("label", null, t("upload:checkbox-mesh-outline-label", "Outline"))),
        currentOptions.outline && (React.createElement(HTMLTooltipWrapper, { tooltip: t("upload:input-mesh-outline-color-tooltip", "The color of the outline") },
            React.createElement(ColorSelect, { color: currentOptions.color, label: t("upload:input-mesh-outline-color-label", "Outline-Color:"), onColorChanged: (color) => {
                    setCurrentOptions(Object.assign(Object.assign({}, currentOptions), { color: color }));
                } })))));
}
